import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const saveNewEmail = async (code, successMessage = 'Почта привязана') => {
  try {
    const response = await client.post(
      '/Profile/verify_mail',
      {},
      {
        headers: authHeader(),
        params: { code },
      }
    );
    if (response.data.result === 'Error') {
      message.error(response.data.message);
      return false;
    } else {
      message.success(successMessage);
      return true;
    }
  } catch (e) {
    console.error(e);
    message.error('Произошла ошибка');
    return false;
  }
};

export default saveNewEmail;
